import ZoneList from "../../features/marketingManager/ZoneList"

const ZoneListPage = () => {
    return <ZoneList />
}

export default ZoneListPage